import React from 'react';
import PropTypes from 'prop-types';

const SentDocument = props => {
  const { color: _color, width: _width, height: _height, ...other } = props;

  return (
    <svg id="グループ_4197" data-name="グループ 4197" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...other}>
      <g id="グループ_4178" data-name="グループ 4178">
        <circle id="楕円形_35" data-name="楕円形 35" cx="16" cy="16" r="16" fill="#f2fff9" />
        <g id="グループ_4181" data-name="グループ 4181" transform="translate(8.295 10.727)">
          <g id="グループ_4179" data-name="グループ 4179" transform="translate(0 3.469)">
            <rect id="長方形_667" data-name="長方形 667" width="9.378" height="6.8" rx="2" fill="#c4ffe4" />
            <path id="多角形_6" data-name="多角形 6" d="M1.65.76a.5.5,0,0,1,.868,0L3.741,2.9a.5.5,0,0,1-.434.748H.862A.5.5,0,0,1,.427,2.9Z" transform="translate(5.622 8.884) rotate(180)" fill="#c4ffe4" />
          </g>
          <g id="グループ_4180" data-name="グループ 4180" transform="translate(5.55)">
            <rect id="長方形_667-2" data-name="長方形 667" width="9.378" height="6.8" rx="2" fill="#22d179" />
            <path id="多角形_6-2" data-name="多角形 6" d="M1.65.76a.5.5,0,0,1,.868,0L3.741,2.9a.5.5,0,0,1-.434.748H.862A.5.5,0,0,1,.427,2.9Z" transform="translate(8.397 8.884) rotate(180)" fill="#22d179" />
          </g>
        </g>
      </g>
    </svg>
  );
}

SentDocument.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

SentDocument.defaultProps = {
  color: '#f2fff9',
  width: 32,
  height: 32,
};

export default SentDocument;



// WEBPACK FOOTER //
// ./src/components/Icons/SentDocument.jsx